import React, { useState } from 'react';
import { Platform } from 'react-native';
import { useSelector } from 'react-redux';
import IconInput from 'src/components/IconInput/IconInput';
import CustomDatePicker from 'src/components/CustomDatePicker/CustomDatePicker';
import WebDateYMD from 'src/components/WebDatePickerInput/WebDatePickerInput';
import { toISO, fromISO, formatDate, parseYMDToLocalDate } from 'src/helpers/dateHelper';
import { RootState } from 'src/store/store';
import dateIcon from 'src/assets/date.png';

interface OwnerDobProps {
  dob: Date | null;
  setDob: (date: Date) => void;
}

const OwnerDob: React.FC<OwnerDobProps> = ({ dob, setDob }) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const accountType = useSelector((state: RootState) => state.UI.accountType);
  const isProducerWeb = accountType === 'producer' && Platform.OS === 'web';

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Ensure today is at midnight

  const handleWebDateChange = (iso: string | null) => {
    const parsed = fromISO(iso);
    if (parsed && parsed <= today) {
      setDob(parsed); // Clamp to maxDate (today)
    }
  };

  return isProducerWeb ? (
    <WebDateYMD
      testID={'insurance-policy-final-dob'}
      label="Owner's Date of Birth"
      valueISO={toISO(dob)}
      onChangeISO={handleWebDateChange}
    />
  ) : (
    <>
      <IconInput
        label="Owner's Date of Birth"
        value={dob ? formatDate(dob, 'MMM DD YYYY') : ''}
        placeholder="Select date of birth"
        iconSource={dateIcon}
        iconWidth={20}
        iconHeight={20}
        onPress={() => setIsDatePickerOpen(true)}
        onIconPress={() => setIsDatePickerOpen(true)}
      />
      <CustomDatePicker
        customHeader="Owner's Date of Birth"
        value={parseYMDToLocalDate(dob?.toString()) || new Date(Date.now())}
        isOpen={isDatePickerOpen}
        onSelect={(date) => {
          setDob(date);
          setIsDatePickerOpen(false);
        }}
        onCancel={() => setIsDatePickerOpen(false)}
        maxDate={new Date()}
      />
    </>
  );
};

export default OwnerDob;
